import * as React from 'react';
import { times } from 'lodash';
import styled from 'styled-components';

import { Card, Button, CheckmarkIcon, Typography, BackspaceIcon, CancelIcon } from '../material-ui';
import styleObject from '../style-object';

const Wrapper = styled(Card)`
	padding: 1rem;
	width: 20rem;
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	justify-content: center;
`;

const DisplayRow = styled.div`
	width: 20rem;
	margin: 1rem 0.5rem 0.5rem 0.5rem;
	padding-left: 2rem;
	border-radius: 0.5rem;
	background-color: rgba(0, 0, 0, 0.08);
	display: flex;
	flex-flow: row;
	justify-content: space-between;
	align-items: center;
	overflow: hidden;
`;

const Input = styled(Typography).attrs({
	variant: 'button',
})`
	font-size: 1.5rem !important;
`;

const ConfirmButton = styled(Button).attrs({
	color: 'primary',
	variant: 'contained',
})`
	min-width: 4rem !important;
	height: 4rem;
	box-shadow: none !important;
	border-radius: 0 !important;
`;

const NumberButton = styled(Button)`
	height: 4rem;
	font-size: 1.5rem !important;
	font-weight: 900 !important;
	min-width: 5rem !important;
	margin: 0.5rem !important;
`;

const checkmarkStyle = styleObject`
	font-size: 26px;
`;

const CloseIcon = styled(CancelIcon).attrs({
	fontSize: 'inherit',
	color: 'disabled',
})`
	position: absolute;
	top: -0.5rem;
	left: -0.5rem;
	cursor: pointer;
	background: white;
	border-radius: 100%;
	font-size: 2rem !important;
`;

export class Dialpad extends React.Component {
	constructor(props) {
		super(props);
		this.state = { input: props.defaultValue || '' };
	}

	handleInput = (i) => () => this.setState(({ input }) => ({ input: input + i }));

	handleClear = () => this.setState({ input: '' });

	handleBackspace = () =>
		this.setState(({ input }) => ({ input: input.substring(0, input.length - 1) }));

	hanldeSubmit = () => this.props.onSubmit && this.props.onSubmit(this.state.input);

	render = () => (
		<Wrapper>
			<CloseIcon onClick={this.props.onClose} />
			<DisplayRow>
				<Input>{this.state.input}</Input>
				<ConfirmButton onClick={this.hanldeSubmit}>
					<CheckmarkIcon style={checkmarkStyle} />
				</ConfirmButton>
			</DisplayRow>
			{times(9, (i) => i + 1).map((i) => (
				<NumberButton key={i} onClick={this.handleInput(i)}>
					{i}
				</NumberButton>
			))}
			<NumberButton onClick={this.handleClear}>
				<CancelIcon />
			</NumberButton>
			<NumberButton onClick={this.handleInput(0)}>0</NumberButton>
			<NumberButton>
				<BackspaceIcon onClick={this.handleBackspace} />
			</NumberButton>
		</Wrapper>
	);
}



// WEBPACK FOOTER //
// ./src/components/Dialpad.js